import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Lleva la ventana al inicio cada vez que cambia la ruta.
 *
 * En React Router las navegaciones mantienen la posición previa del scroll,
 * por lo que al cambiar de página desde el menú o enlaces se quedaba a mitad.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as any });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
